// React Bootstrap imports
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
// import NavDropdown from "react-bootstrap/NavDropdown";
import { Link, useNavigate } from "react-router-dom";
// import portfolio from "../../db/project_database";

// import navigation styles
import "../styles/Navigation.scss";

const Navigation = () => {
  const navigate = useNavigate();

  const handleBlogClick = () => {
    navigate("/blogs");
  }

  const handleAboutClick = () => {
    navigate("/about")
  }

  const handleProjectsClick = () => {
    navigate("/projects")
  }

  // const handleResumeClick = () => {
  //   navigate("/resume")
  // }

  const handleStuffClick = () => {
    navigate("/now")
  }

  // const generateDropdowns = () => {
  //   const dropdownList = Object.keys(portfolio).map((key) => {
  //     return (
  //       <NavDropdown.Item href={`/project/${key}`} key={portfolio[key].name}>
  //         {portfolio[key].name}
  //       </NavDropdown.Item>
  //     );
  //   });

  //   return dropdownList;
  // };

  return (
    <Navbar variant="dark" expand="lg" className="navbar">
      <Container>
        <div>
          <Link to={"/"} className="navbar--brand">
            <Navbar.Brand>open-meadow</Navbar.Brand>
          </Link>
        </div>
        <div>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav>
              <Nav.Link onClick={handleBlogClick}>Blog</Nav.Link>
              {/* <NavDropdown title="Projects">{generateDropdowns()}</NavDropdown> */}
              <Nav.Link onClick={handleStuffClick}>Now</Nav.Link>
              <Nav.Link onClick={handleProjectsClick}>Projects</Nav.Link>
              {/* <Nav.Link onClick={handleResumeClick}>Resume</Nav.Link> */}
              <Nav.Link onClick={handleAboutClick}>About</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </div>
      </Container>
    </Navbar>
  );
};

export default Navigation;
